import React from "react";
import style from "../assets/css/GraduateProfile.module.css";

export const Logo = () => (
  <img
    src="/img/Logo-suiza.png"
    alt="Instituto Suiza Logo"
    className={style.centeredImage}
  />
);
